"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var thirty_two_1 = require("thirty-two");
var getRandomBytes_1 = require("./getRandomBytes");
function generateKey() {
    // 32 ascii characters
    return thirty_two_1.encode(getRandomBytes_1.getRandomBytes(20)).toString('utf8')
        // without trailing '='s
        .replace(/=/g, '')
        // lowercase with a space every 4 characters
        .toLowerCase()
        .replace(/(\w{4})/g, '$1 ')
        .trim();
}
exports.generateKey = generateKey;
